<template lang="pug">
  section
    header.header-settings
      .tabs
        .tab.primary-text.active
          span Statuses

    p Define your own feature status labels.

    has-access(allowance="customStatus")
      form(@keyup.enter="submit", @submit.prevent="submit")
        section.sub-section
          div.form-field.no-margin
            table
              tr
                th.center Default
                th.center Final
                th Status Text
                th.center Text Color
                //-th.center Background
                th
              tr(v-for="(v, index) in $v.statusesForm.$each.$iter", :class="{ 'deleting': statusesForm[index].deleted }")
                td.center
                  label
                    input(:value="true", type="radio", @change="selectDefault(index)", v-model="statusesForm[index].default")
                td.center
                  label
                    input(v-model="v.final.$model", type="checkbox")
                td
                  .form-field.no-margin(:class="{error: v.$error }")
                    label
                      input(v-model="v.label.$model", type="text")
                td.center
                  verte(picker="square", v-model="statusesForm[index].bgColor", :draggable="false")
                    color-swatch(:color="statusesForm[index].bgColor")
                  //-sketch-picker(v-model="status.bgColor")
                  //-input(v-model="status.bgColor", type="text")
                td.center
                  button.button.button-none(type="button", @click="remove(index)")
                    font-awesome-icon(:icon="['fas', 'times']", fixed-width, v-if="!statusesForm[index].deleted")
                    font-awesome-icon(:icon="['fas', 'undo']", fixed-width, v-if="statusesForm[index].deleted")
        div.form-field.no-margin
          button.button(type="button", @click="add") Add
          SubmitButton(label="Save", :formState="formState")
          //-button.button.primary-button(type="submit") Save
          //-button.button.button-primary(type="submit", :disabled="!$v.$anyDirty") Save
</template>

<script>

import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { form } from '@/mixins/form'

import ColorSwatch from '@/components/helpers/ColorSwatch'

import Verte from 'verte'
import 'verte/dist/verte.css'


const hasFinalStatus = statuses => {
  let final = false
  statuses.forEach(status => {
    if (status.final) {
      final = true
    }
  })
  //console.log('final', final)
  return final
}


const statusRow = {
  default: false,
  final: false,
  label: '',
  color: '',
  bgColor: ''
}

export default {
  name: 'SettingsStatuses',
  components: {
    Verte,
    ColorSwatch
  },
  mixins: [form],
  mounted () {
    this.statusesForm = this.statuses
    //console.log(this.statusesForm)
  },
  data () {
    return {
      formState: 'initial',
      statusesForm: []
    }
  },
  validations: {
    statusesForm: {
      $each: {
        default: {
          required
        },
        label: {
          required
        },
        final: {
          required
        }
      },
      hasFinalStatus
    }
  },
  computed: {
    ...mapState({
      statuses: state => state.statuses
    })
  },
  methods: {
    selectDefault (selected) {
      this.statusesForm.forEach((status, i) => {
        if (i != selected) {
          status.default = false
          this.$set(this.statusesForm, i, status)
        }
      })
    },
    selectFinal (e) {
      //console.log(e)
      this.statusesForm.forEach(status => {
        status.final = status._id === e.target.value
      })
      //console.log(this.statusesForm)
    },
    add () {
      let status = Object.assign({}, statusRow)
      status.order = this.statusesForm.length
      this.statusesForm.push(status)
    },
    remove (index) {
      if (this.statusesForm[index].hasOwnProperty('deleted')) {
        this.$delete(this.statusesForm[index], 'deleted')
      } else {
        this.$set(this.statusesForm[index], 'deleted', true)
      }
    },
    submit () {
      //console.log('submitting!')
      let data = {
        statuses: this.statusesForm
      }
      //console.log(data)
      if (this.__formInvalid()) return

      //console.log('here')

      this.formState = 'pending'
      this.$store.dispatch('postStatuses', data)
        .then(() => {
          this.formState = 'success'
        }, () => {
          this.formState = 'error'
        })
    },
  },
  watch: {
    statuses (statuses) {
      this.statusesForm = statuses
    }
  }
}
</script>

<style lang="stylus" scoped>
p
  margin-bottom $spacing-3
table
  position relative
tr.deleting
  opacity .5
  &:after
    content ''
    position absolute
    left 0
    right 70px
    height 2px
    background-color #000
    margin-top 32px

</style>
